module.controller('audioCntrl', function($document, esb, xmppAuth, services, $sce, $scope, $http, $mdDialog, $window, theme, $timeout) {

  var index = $window.sessionStorage.getItem("modalAudioCapture");
  $scope.textLabel = $window.sessionStorage.getItem("modalAudioCaptureLabel");
   
  $scope.iconRecord = "recordon";
  $scope.iconPlay = "playoff";
  $scope.isPlayingAudio = false;
  $scope.isRecording = false;
  $scope.clock = "Presione para grabar"; // initialise the time variable
  $scope.tickInterval = 1000;
  $scope.ti = 0;
  $scope.audioSrc;
  var mytimeout;
  let shouldStop;
  let stopped;
  let mediaRecorder;
  let audio;
  var lastBlob; 
  function stopRecord() {
    $scope.isRecording = false;
    $scope.iconRecord = "recordon";
    $scope.existAudio = true;
    $timeout.cancel(mytimeout);
    shouldStop = true;
    $scope.isPlayingAudio = false;
    $scope.clock = "Presione para grabar";

  }

  $scope.stopPlayPublic = function () {
    $scope.isPlayingAudio = false;
    $scope.iconPlay = "playoff";
  }

  function pausePlay() {
    $scope.isPlayingAudio = false;
    $scope.iconPlay = "playoff";
  }

  function stopPlay() {
    $scope.isPlayingAudio = false;
    $scope.iconPlay = "playoff";
  }

  $scope.startRecord = function () {
    if ($scope.isRecording) {
      stopRecord();
    }
    else {
      navigator.mediaDevices.getUserMedia({ "audio": true })
      .then(handleSuccess)
      .catch(errorCallback);
    }

  }
  let errorCallback = (err) => {
    
    var message = "";
    if (err.name == "NotFoundError" || err.name == "DevicesNotFoundError") {
      message = "El micrófono es requerido para utilizar esta funcionalidad";
  } else if (err.name == "NotReadableError" || err.name == "TrackStartError") {
    message = "Debe habilitar los permisos de micrófono";
  } else if (err.name == "OverconstrainedError" || err.name == "ConstraintNotSatisfiedError") {
    message = "Ha ocurrido un error al activar el micrófono";
  } else if (err.name == "NotAllowedError" || err.name == "PermissionDeniedError") {
      //permission denied in browser 
      message = "Debe habilitar los permisos de micrófono";

  } else if (err.name == "TypeError" || err.name == "TypeError") {
    message = "Ha ocurrido un error al activar el micrófono";
  } else {
    message = "Debe habilitar los permisos de micrófono";
  }
  alert(message);
    console.log('navigator.getUserMedia error: ', err);
  };

  let handleSuccess = function (stream) {
    let options;
    let recordedChunks = [];
    shouldStop = false;
    stopped = false;
    mediaRecorder = new MediaRecorder(stream);
    if (audio != null) {
      audio.pause();
      audio.currentTime = 0;
    }
    $scope.isRecording = true;
    $scope.iconRecord = "stoponn";
    $scope.ti = 0;

    mediaRecorder.start(10);
    mytimeout = $timeout(tick, $scope.tickInterval);
    mediaRecorder.addEventListener('dataavailable', function (e) {
      if (e.data.size > 0) {
        recordedChunks.push(e.data);
      }

      if (shouldStop === true && stopped === false) {
        mediaRecorder.stop();
        stream.getAudioTracks().forEach(function (track) {
          track.stop();
        });
        stopped = true;
      }
    });

    mediaRecorder.addEventListener('start', function (e) {
      console.log('Started, state = ' + mediaRecorder.state);
    });

    mediaRecorder.addEventListener('stop', function () {
      audio = document.getElementById('audio');
      lastBlob = new Blob(recordedChunks,{type:'audio/aac'});
      audio.src = URL.createObjectURL(lastBlob);
    });

    mediaRecorder.addEventListener('warning', function (e) {
      log('Warning: ' + e);
    });

    mediaRecorder.addEventListener('error', evt => {
      reject(evt);
    });
  };

  var tick = function () {
    $scope.ti++;
    var hr = (Math.floor($scope.ti / 3600) < 10) ? ("0" + Math.floor($scope.ti / 3600)) : (Math.floor($scope.ti / 3600));
    var min = (Math.floor($scope.ti / 60) < 10) ? ("0" + Math.floor($scope.ti / 60)) : (Math.floor($scope.ti / 60));
    var sec = $scope.ti % 60 < 10 ? ("0" + $scope.ti % 60) : ($scope.ti % 60);
    $scope.clock =  min + ":" + sec;
    mytimeout = $timeout(tick, $scope.tickInterval);
  }

  $scope.startPlay = function () {
    if ($scope.isPlayingAudio) {
      pausePlay();
    }
    else {
      $scope.isPlayingAudio = true;
      $scope.iconPlay = "pauseon";
    }

  }


  $scope.sendAudio = function(){
    if($scope.existAudio === true) {
      $scope.progressCircular = "ok";
        var blobUrl = audio.src;
        const payload = new FormData();
        payload.append('type', 'talk');
        payload.append('fileExtension', 'aac');
        payload.append('latitude', "1");
        payload.append('longitude', "1");
        payload.append('file', lastBlob, 'voice.aac');
        var file = URL.createObjectURL(lastBlob);
        services.user.userServices('bearer '+$window.localStorage.getItem('access_token1')).uploadReceipt({}, payload, function(response, event){
            $scope.progressCircular = undefined;
            if(response.data.url){
              var data = {};
              data.url = response.data.url
              data.fileName = file;
              $mdDialog.hide(data);
            }
        });
    }
  }

  $scope.closeDialog = function(){
    $mdDialog.cancel();
};
$scope.hideDialog = function(data){   
   $mdDialog.hide(data.url);
}; 
  $scope.renderHtml = function(htmlCode) {
    if(htmlCode){
      return $sce.trustAsHtml(htmlCode);
    }
  };
});